import React from "react";
import NumberFormat from "react-number-format";
import { connect } from "react-redux";

import cookie from "react-cookies";
import { isIOS } from "react-device-detect";
import { moment } from "../../../common/common";


import { getLoggedProfile, getListAddress } from "../../../../actions/sessionAct";

import { setBooking, getCSDetail } from "../../../../actions/csDetailAct";

import { searchInHouse } from "../../../../model/common";

import { LoadingInline, Loading } from "../../../common/loading";
import { commonErr } from "../../../common/errors";
import {
	formatPrice,
	stypes,
	isEmptyObj,
	convertSecondToTime,
	getBookingTimes
} from "../../../common/common";

import { MessageErr } from "../../../common/messagebox";

import CSBooking from "../csbooking";

import { Surcharge } from "./surchage";

import { VerifyPhoneDL, VerifyPhoneBox, VerifyLicense, LicenseForm } from "../../../car/components/verifybox";
import { TooltipP } from "../../../components/tooltip";

import ChangeDriverLicense from "../../../account/changedriverlicense";
import ChangePhone from "../../../account/changephone";
import VerifyPhoneOpt from "../../../account/verifyphoneopt";
import VerifyPhoneOptBreak from "../../../account/verifyphoneoptbreak";

import { TimeSelect } from "../../components/timeselect"
import { OptionalTime } from "../../components/optionaltime";
import  OptionalDate from "../../components/optionaldate";
import {
	IcInfomationTriangle,
} from "../../../common/svg";
import { TooltipCustom } from "../../../components/tooltip";

var Buffer = require("buffer/").Buffer;


// const listPickupRange = [
//     {key: 3, value: moment().add(3, 'days').set({
// 		hour: 0,
// 		minute: 0,
// 		second: 0,
// 		milliseconds: 0,
// 	}).valueOf(), label: "3 ngày tới" },
//     {key: 7, value: moment().add(7, 'days').set({
// 		hour: 0,
// 		minute: 0,
// 		second: 0,
// 		milliseconds: 0,
// 	}).valueOf(), label: "1 tuần tới" },
//     {key: 14, value: moment().add(14, 'days').set({
// 		hour: 0,
// 		minute: 0,
// 		second: 0,
// 		milliseconds: 0,
// 	}).valueOf(), label: "2 tuần tới" }
// ]

class SideBar extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			err: commonErr.INNIT,
			errMsg: "",

			car: props.detail.info,
			selfPickup: true,
			promoCode: null,
			fromAddress: "",
			fromAddressLat: 0,
			fromAddressLng: 0,
			dateNotAvail: 0,

			showWarningForm: false,
			showVerifyLicense: false,
			showNotifLicense: false,
			isShowBooking: false,
			showDetailIns: false,
			showChangePhone: false,
			showChangeDriverLicense: false,
			showVerifyPhoneOpt: false,

			pickupTimesStr: "",
			returnTimesStr: "",
			minTimesRepeatDetected: "",

			
			isDeliveryByAddressCar: false,
			deliveryAddressChangedFlag: false,
			isValidPickupReturnTimes: true,

			isOpenAlertPromBox: false,

			deliveryId: props.deliveryId,

			showDateRangePicker: false,
		
			isSelectTimeCS: false,
			isSelectPickup: false,
			isOptionalTime: false,
			isOptionalDate: false,
			timeCS: 6,
			numberDay: 3
		};

		this.stype = this.props.stype;
		this.isSD = this.props.stype === stypes.SD;

		this.wrapperSelectCD = React.createRef();
		this.map = React.createRef();
	}

	componentDidMount() {
	
			// CHECK IS OWNER
			// NOTE:
			// Set state isOwner, may be missed, because Header call dispath(init()), store change after Bookingsidebar did mount
			// Missed value. Can handle both in componentWillRecieveProps to makesure success
			this.setState({
				isOwner:
					this.props.loggedProfile &&
					this.props.loggedProfile.uid &&
					this.props.loggedProfile.uid === this.props.detail.info.ownerId,
			});
			// GET VALUE OF COOKIE FOR PARAMS TO GETCARPRICE
			// All params: startDate, endDate, promoCode, selfPickup, fromAddress, fromAddressLat, fromAddressLng
		
			var startDate;
			var endDate;
			let timeCS;
			
			const { booking } = this.props.csDetail
			// var promoCode = cookie.load("_promo");

			const cStartTs = cookie.load("_mstartcs");
			const cEndTs = cookie.load("_mendcs");
			const cTimeCs = cookie.load("_mtimecs");
			cookie.remove("_mtimecs", { path: "/" });

			if (!cStartTs || !cEndTs || !cTimeCs) {
				cookie.remove("_mstarttscs", { path: "/" });
				cookie.remove("_mendtscs", { path: "/" });
				cookie.remove("_mtimecs", { path: "/" });
			}
	
		
			if (cStartTs && cEndTs && cTimeCs) {
			
				startDate = moment(cStartTs * 1);
				endDate = moment(cEndTs * 1);

				timeCS = cTimeCs * 1;
			
			
			
				const ex = {
					st: startDate,
					et: endDate,
					skuGroupId: booking.skuGroupId,
					lat: booking.lat,
					lon: booking.lon,
					timeCS: timeCS
				};

				this.setBooking(ex)
				this.getCar(ex);
			}

	
			const car = this.props.csDetail.detail.info;
			if (this.props.csDetail.detail && car) {
		
				const groupYear = car.years[0]
				const daysAvailableInSeconds = groupYear && groupYear.daysAvailableInSeconds
				const dayAvailable = parseInt(daysAvailableInSeconds / 3600 / 24)
				const labelTextDay = daysAvailableInSeconds && convertSecondToTime(daysAvailableInSeconds)
				let timeCS = 6
			
				const listPickupRange = [
					{key: dayAvailable, value: moment().add(dayAvailable, 'days').set({
						hour: 0,
						minute: 0,
						second: 0,
						milliseconds: 0,
					}).valueOf(), label: labelTextDay}
					]

				
				
				if (startDate?.valueOf() !== listPickupRange[0].value) {

					startDate = moment(listPickupRange[0].value);

					endDate = moment(startDate).add(timeCS, "months").set({
						hour: 0,
						minute: 0,
						second: 0,
						milliseconds: 0,
					})

					const ex = {
						st: startDate,
						et: endDate,
						skuGroupId: booking.skuGroupId,
						lat: booking.lat,
						lon: booking.lon,
						timeCS: timeCS
					};
	
					this.setBooking(ex)
					this.getCar(ex);
				}
				
			

				this.setState({
					yearPicker: { yFrom: groupYear.yearFrom, yTo: groupYear.yearTo },
					listPickupRange: listPickupRange,
					groupYear: groupYear,
					numberDay: dayAvailable
				})
			}

			
		
		document.addEventListener("click", this.handleClick);
		// window.addEventListener("resize", this.updateDimensions);
	}

	componentDidUpdate(prevProps) {
		if (prevProps.loggedProfile !== this.props.loggedProfile) {
			// this.getListAddress();
			this.setState({
				isOwner:
					this.props.loggedProfile &&
					this.props.loggedProfile.uid &&
					this.props.loggedProfile.uid === this.state.car.ownerId,
			});
		}
	
	}

	UNSAFE_componentWillMount() {
		// important
		document.removeEventListener("click", this.handleClick);
	}



	handleClick = (event) => {
		const { target } = event;

		if (target !== null && this.wrapperSelectCD.current !== null && !this.wrapperSelectCD.current.contains(target)) {
			const { isSelectPickup} = this.state;
			if (isSelectPickup) {
				this.setState({
					isSelectPickup: false,
				});
			}
		}
	};



	getCarPriceAndCheckTime = (params) => {
		const {
			selfPickup,
			startDate,
			endDate,
			fromAddress,
			fromAddressLat,
			fromAddressLng,
			calendar,
			deliveryId,
		} = params;
		let { promoCode } = params;
		const car = this.props.detail.info;

		if (this.state.err < commonErr.SUCCESS || !startDate || !endDate) {
			return;
		}



			if (!selfPickup && fromAddress != car.locationAddr && fromAddress !== "") {
				if (!fromAddressLat || !fromAddressLng || fromAddressLat === 0 || fromAddressLng === 0) {
					searchInHouse(fromAddress).then((response) => {
						if (response.data.data && response.data.data.locations.length > 0) {
							const loc = response.data.data.locations[0];
							location = { lat: loc.lat, lng: loc.lon };
							const ex = {
								carId: car.id,
								st: startDate,
								et: endDate,
								latD: latLng.lat,
								lngD: latLng.lng,
								promo: promoCode,
								deliveryId: deliveryId,
								stype: this.stype,
								vw: 'cd'
							};
							this.getCar(ex, calendar);
						}
					});
				} else {
					const ex = {
						carId: car.id,
						st: startDate,
						et: endDate,
						latD: fromAddressLat,
						lngD: fromAddressLng,
						promo: promoCode,
						deliveryId: deliveryId,
						stype: this.stype,
						vw: 'cd'
					};

					this.getCar(ex, calendar);
				}
			}
			
		
	};

	getCar = (ex, calendar) => {
		this.props.dispatch(getCSDetail(ex)).then((response) => {
			const resp = response.action.payload;
			if (resp.data.error === commonErr.SUCCESS && resp.data.data) {
			
				const priceSummary = resp.data.data.car.years[0].priceSummary
				let listMonths = priceSummary.map(price => price.totalMonths);
				

			
				this.setState({
					err: resp.data.error,
					car: resp.data.data.car,
					dateNotAvail: resp.data.data.dateNotAvail,
					listMonths: listMonths,
		
				});
			} else {
				this.setState({
					err: commonErr.FAIL,
					errMsg: resp.data.errorMessage,
				});
			}
		});
	};

	getProfile = () => {
		this.props.dispatch(getLoggedProfile());
	};



	setBooking = (f) => {
		this.props.dispatch(setBooking(f));
	};


	openWarningForm = () => {
		this.setState({
			showWarningForm: true,
		});
	};

	closeWarningForm = () => {
		this.setState({
			showWarningForm: false,
		});
	};

	openVerifyForm = () => {
		this.setState({
			showVerifyForm: true,
		});
	};

	closeVerifyForm = () => {
		this.setState({
			showVerifyForm: false,
		});
	};

	openVerifyLicense = () => {
		this.setState({
			showVerifyLicense: true,
		});
	};

	closeVerifyLicense = () => {
		this.setState({
			showVerifyLicense: false,
		});
	};

	openNotifLicense = () => {
		this.closeVerifyLicense();
		this.closeVerifyForm();

		this.setState({
			showNotifLicense: true,
		});
	};

	closeNotifLicense = () => {
		this.setState({
			showNotifLicense: false,
		});
	};



	openDetailIns = () => {
		this.setState({
			showDetailIns: true,
		});
	};

	closeDetailIns = () => {
		this.setState({
			showDetailIns: false,
		});
	};

	rentCarBtnClick = (e) => {
		const { car } = this.state;
		const { loggedProfile } = this.props;

		if (!loggedProfile || !loggedProfile.uid) {
			this.props.showLoginForm();
		} else if (
			car.requiredDriverLicense &&
			loggedProfile &&
			loggedProfile.phoneVerified === 1 &&
			((loggedProfile.driverLicenseStatus > 4 && loggedProfile.driverLicenseStatus < 40) ||
				loggedProfile.driverLicenseStatus < 1)
		) {
			this.openVerifyLicense();
		} else if (
			car.requiredDriverLicense &&
			loggedProfile &&
			loggedProfile.phoneVerified !== 1 &&
			((loggedProfile.driverLicenseStatus > 4 && loggedProfile.driverLicenseStatus < 40) ||
				loggedProfile.driverLicenseStatus < 1)
		) {
			this.openVerifyForm();
		} else if (loggedProfile && loggedProfile.phoneVerified !== 1) {
			this.openWarningForm();
		} else if (loggedProfile && loggedProfile.uid === car.ownerId) {
			this.setState({
				isOwner: true,
			});
		} else {
			//GA
			// const utmSrc = cookie.load("_utm_src") || "web_directly";
			// const utmExt = cookie.load("_utm_ext") || "no_label";
			// window.fbq("track", "CONFIRM_BOOKING");
			// window.gtag("event", "CONFIRM_BOOKING", {
			// 	event_category: utmSrc,
			// 	event_label: utmExt,
			// 	campaign: { source: utmSrc },
			// });
			this.openBooking();
		}
	};




	isValidBooking = () => {
		// Common
		let ret =
			this.state.car &&
			!this.state.isOwner &&
			this.state.dateNotAvail <= 0 &&
			this.state.startDate &&
			this.state.endDate &&
			this.state.endDate.isValid() &&
			this.state.err >= commonErr.SUCCESS &&
			this.state.err !== commonErr.INNIT &&
			this.state.err !== commonErr.LOADING &&
			isEmptyObj(this.state.minTimesDetected) &&
			this.state.isValidPickupReturnTimes;
	

		return ret;
	};

	openBooking = () => {
		this.setState({
			isShowBooking: true,
		});
	};

	closeBooking = () => {
		this.setState({
			isShowBooking: false,
		});
	};

	hideMessageBox = () => {
		this.setState({
			err: commonErr.SUCCESS,
			errMsg: "",
		});
	};



	showChangePhone = () => {
		this.setState({
			showChangePhone: true,
		});
		this.closeWarningForm();
	};

	hideChangePhone = () => {
		this.setState({
			showChangePhone: false,
		});
	};

	showVerifyPhoneOpt = () => {
		this.setState({
			showVerifyPhoneOpt: true,
		});
	};

	hideVerifyPhoneOpt = () => {
		this.setState({
			showVerifyPhoneOpt: false,
		});
	};

	showVerifyPhoneOptBreak = () => {
		this.setState({
			showVerifyPhoneOptBreak: true,
		});
	};

	hideVerifyPhoneOptBreak = () => {
		this.setState({
			showVerifyPhoneOptBreak: false,
		});
	};

	showChangeDriverLicense = () => {
		this.setState({
			showChangeDriverLicense: true,
		});
		this.closeNotifLicense();
	};

	hideChangeDriverLicense = () => {
		this.setState({
			showChangeDriverLicense: false,
		});
	};


	openCalendar = () => {
		this.setState({
			isCalendar: true
		})
	}

	hideCalendar = () => {
		this.setState({
			isCalendar: false
		})
	}



	onYearPickerChange = (e, year) => {
		let { st, et, timeCS } = this.props.csDetail.booking;
		const { numberDay } = this.state; 
		const daysAvailableInSeconds = year && year.daysAvailableInSeconds
		const dayAvailable = parseInt(daysAvailableInSeconds / 3600 / 24)

		if (numberDay !== dayAvailable) {
			this.setState({
				numberDay: dayAvailable
			})
		}
		
		st = moment().add(dayAvailable, "days").set({
			hour: 0,
			minute: 0,
			second: 0,
			milliseconds: 0,
		});
		et = moment(st).add(timeCS, "months").set({
			hour: 0,
			minute: 0,
			second: 0,
			milliseconds: 0,
		})

		const ex = {
			...this.props.csDetail.booking, 
			st: st,
			et: et 
		};

		this.setBooking(ex)

		this.setState({
			yearPicker: { 
				yFrom: Number(e.target.value),
				yTo: year.yearTo
			},
			groupYear: year,
		})
		
	}

	onSelectTimeCSChange = (e) => {
		let { st, et } = this.props.csDetail.booking;
		const time = e.target.value; 
		
		et = moment(st).add(time, 'months').set({
			hour: 0,
			minute: 0,
			second: 0,
			milliseconds: 0,
		}) ;
		const f = {
			...this.props.csDetail.booking,
			timeCS: time*1,
			et
		}

		this.setBooking(f)
		// this.getCar(f)
		
		

	}

	onStartDateChange = (e) => {
		let numberDay = Number(e.target.value); 
		let { st, et, timeCS } = this.props.csDetail.booking; 
		const { groupYear } = this.state

		const daysAvailableInSeconds = groupYear && groupYear.daysAvailableInSeconds
		const dayAvailable = parseInt(daysAvailableInSeconds / 3600 / 24)
		// const labelTextDay = daysAvailableInSeconds && convertSecondToTime(daysAvailableInSeconds)
	
		
		if (numberDay > 0) {
	
			if (dayAvailable == numberDay) {
				
				this.setState({
					numberDay: dayAvailable
				})
				st = moment().add(dayAvailable, 'days').set({
					hour: 0,
					minute: 0,
					second: 0,
					milliseconds: 0,
				});

				et = moment(st).add(timeCS, 'months').set({
					hour: 0,
					minute: 0,
					second: 0,
					milliseconds: 0,
				})

				const ex = {
					...this.props.csDetail.booking, 
					st: st,
					et: et 
				};
		
				this.setBooking(ex)
			} 
			
			} else {
				this.setState({
					numberDay: 0
				})
				this.showCalendar()
			}

	}

	onCustomDateChange = (date) => {
		let { et, timeCS } = this.props.csDetail.booking; 

		et = moment(date).add(timeCS, 'months').set({
			hour: 0,
			minute: 0,
			second: 0,
			milliseconds: 0,
		});
	

		const ex = {
			...this.props.csDetail.booking, 
			st: date,
			et: et 
		};

		this.setBooking(ex);
		this.getCar(ex);
	}

	
	showOptionalTime = () => {
		this.setState({
			isOptionalTime: true
		})
	}

	hideOptionalTime = () => {
		this.setState({
			isOptionalTime: false
		})
	}

	showCalendar = () => {
		this.setState({
			isOptionalDate: true
		})
	}

	hideCalendar= () => {
		this.setState({
			isOptionalDate: false
		})
	}


	toggleSelectTimeCS = () => {
		const { isSelectTimeCS } = this.state;

		this.setState({
			isSelectTimeCS: !isSelectTimeCS,
		});
	};

	toggleSelectPickup = () => {
		const { isSelectPickup } = this.state;

		this.setState({
			isSelectPickup: !isSelectPickup,
		});
	};

	totalDiscount = (priceSummary) => {
		const totalDiscountPercent = priceSummary && priceSummary.specialDiscount > 0 ? parseInt(priceSummary.specialDiscount/priceSummary.priceOrigin*100) : 0
		return totalDiscountPercent
	}
	tooltRentTitle = () => {
		return (
			<>
				Giá cơ bản
			</>
		);
	}
	tooltRent = () => {
		return (
			<>
				Giá cơ bản là giá tính theo 30 ngày thuê xe & chưa bao gồm khuyến mãi (nếu có)
			</>
		);
	}


	render() {
		let content;
		const { err } = this.state;


		if (this.props.csDetail && this.props.csDetail.detail) {
			const { isMCalendar } = this.props;
			const {
				dateNotAvail,
				isOptionalDate,
				yearPicker,
				isShowBooking,
				numberDay,
				isSelectTimeCS,
				listMonths
			} = this.state;
			let { errMsg } = this.state;
			const car = this.props.csDetail.detail.info;
			
			const { timeCS, st, et, skuGroupId } = this.props.csDetail.booking;

			const groupYear = car.years.filter(year => year.yearFrom == yearPicker?.yFrom)[0]
			
			const skuId = groupYear && groupYear.skuId
			
			const priceFromMonth = groupYear && groupYear.priceSummary.filter(price => price.totalMonths == timeCS)[0]
			const priceSummary = priceFromMonth ? priceFromMonth : undefined
			const totalDiscountPercent = priceSummary && priceSummary.specialDiscount > 0 ? parseInt(priceSummary.specialDiscount/priceSummary.priceOrigin*100) : 0
			
			const daysAvailableInSeconds = groupYear ? groupYear.daysAvailableInSeconds : undefined
			const dayAvailable = daysAvailableInSeconds ?  parseInt(daysAvailableInSeconds / 3600 / 24) : undefined
			const labelTextDay = daysAvailableInSeconds && convertSecondToTime(daysAvailableInSeconds)

			
		
			const listPickupRange = groupYear ?  [
				{key: dayAvailable, value: moment().add(dayAvailable, 'days').set({
					hour: 0,
					minute: 0,
					second: 0,
					milliseconds: 0,
				}).valueOf(), label: labelTextDay}] : []
			
	
			const { loggedProfile } = this.props;
			// let uid = loggedProfile && loggedProfile.uid ? this.props.session.profile.info.uid : undefined;

		

			if (err < commonErr.SUCCESS) {
				errMsg = "Thời gian thuê xe không hợp lệ.";
				
			} else if (dateNotAvail > 0) {

					errMsg = "Xe bận trong khoảng thời gian trên. Vui lòng đặt xe khác hoặc thay đổi lịch trình thích hợp.";
			}
			
			let errBooking = '';


			// const errorDate =
			// 	!isEmptyObj(minTimesDetected) ||
			// 	minTimesRepeatDetected !== "" ||
			// 	(minTimesRepeatDetected && minTimesRepeatDetected !== "") ||
			// 	errMsg !== "";


			content = (
				<>
			
					<div className="car-info" id="cardetail" style={{ position: "relative" }}>
						<div className="highlight-content info-box">
						
        <div className="price"> 
			<>
				{priceSummary && priceSummary.priceOrigin !== priceSummary.priceSpecial && 
					(
						<div className="price-discount">
							<p className="origin">
								<NumberFormat
									value={formatPrice(priceSummary.priceOrigin)}
									displayType={"text"}
									thousandSeparator={","}
									suffix={"K"}
								/> 
							</p>
							{totalDiscountPercent > 0 ? (
								<span className="tag-item discount font-16">-{totalDiscountPercent}%</span>
							) : null}
						</div>
					)}

					{priceSummary && <h4 className="text-primary">
								<NumberFormat
									value={formatPrice(priceSummary.priceSpecial)}
									displayType={"text"}
									thousandSeparator={","}
									suffix={"K /tháng"}
								/> 
						</h4>}

					<div className="note font-12 text-disabled">Đã bao gồm VAT, phí bảo hiểm, giao nhận &amp; bảo dưỡng xe.</div>
				</>
        </div>
		{/* <div className="content price-table"> 

			<div className="price-place">
				<div className="price-inner"> 
					<p className="content-tb">Năm sx</p>
					<TooltipCustom clgTitle={'content-tb'} title={this.tooltRentTitle} desc={this.tooltRent} />
					<p className="content-tb" />
					{car.years?.length > 0 && car.years[0].priceSummary?.map((price, i) => 
						i < 3 ? <p className="content-tb" key={price.totalMonths}>Gói {price.totalMonths}th</p> : null)
					}
				</div>
			
				{car?.years && car?.years.map((year, i) => <React.Fragment key={i.toString()}> 
					<div className="price-inner price-content"> 
					<p className="content-tb">{year.yearFrom}-{year.yearTo}</p>
			
					{year.priceSummary ? <div className="content-tb"> 
						<p className="price fontWeight-8 text-primary font-16">
							<NumberFormat
								value={formatPrice(year.priceSummary[0].priceOrigin)}
								displayType={"text"}
								thousandSeparator={" "}
								suffix={"K"}
							/> 
						</p>
			
					</div>
						
					: "-"}

					<p className="content-tb line" />

					{year.priceSummary.map((price, i) => i < 3 ? <p className="content-tb dis" key={i}>-{this.totalDiscount(price)}%</p> : null)}
				</div>
				{i < (car.years.length - 1) ? <div className="line-page" /> : null}
				</React.Fragment>)}
			</div>
		</div>
      */}
        <div className="line-page" />
		<div className="content"> 
         	 <p className="fontWeight-8">Năm sản xuất</p>
          	<div className="content-box year-place"> 
			{car.years.map((year, i) => <div className="custom-radio" key={i}> 
				<input type="radio" id={`tYear${i}`} name="rTYear" value={year.yearFrom} checked={year.yearFrom == yearPicker?.yFrom} onChange={(e) => this.onYearPickerChange(e, year)} />
				<label htmlFor={`tYear${i}`}>
					<div className={`text ${car.years.length === 1 ? 'item-radius' : ''}`}>
						<p className="year-item">{year.yearFrom === year.yearTo ? year.yearFrom : `${year.yearFrom} - ${year.yearTo}`}</p>
						{year.stock > 0 ? <p className="year-item">({year.stock} xe)</p> : null}
					</div>
				</label>
			</div>)}	
          </div>
        </div>
		<TimeSelect isSelectTimeCS={isSelectTimeCS} wrapperCSSelect={this.wrapperSelectCD} toggleSelectTimeCS={this.toggleSelectTimeCS} timeCS={timeCS} onSelectTimeCSChange={this.onSelectTimeCSChange} cd={true} listMonths={listMonths} />

  
        <div className="content choose-place"> 
          <p className="fontWeight-8">Thời gian nhận xe</p>
          <div className="search-option">
            <div className="search-form__item">
              <div className="choose">
                <div className="choose-item has-arrow" ref={this.wrapperSelectCD}>
                  	<p className="select font-14 fontWeight-4" onClick={this.toggleSelectPickup}>{numberDay === 0 ? st?.format("DD/MM/YYYY") : `${numberDay} ngày tới`}</p>
                 	 {this.state.isSelectPickup && <div className="options">
						{listPickupRange.map((date, i) => <div className="custom-radio" key={`r${i}`}>
							<input id={`rP${date.key}`} type="radio" name="rRangePickup" value={date.key} onChange={this.onStartDateChange} checked={numberDay == date.key} />
							<label htmlFor={`rP${date.key}`}>{date.label}</label>
						</div>)}
				
						<div className="custom-radio">
							<input id="rP0" type="radio" name="rRangePickup" value={0} checked={numberDay === 0} onChange={this.onStartDateChange} />
							<label htmlFor="rP0">{numberDay !== 0 ? "Thời gian khác" : <span onClick={this.showCalendar}>{st?.format("DD/MM/YYYY")}</span>}</label> 
						</div>
								
                  </div>}
                </div>
              </div>
            </div>
          </div>
        </div>

		<div className="line-page" />
        <div className="note-content"> 
          <div className="n-col"> 
            <div className="item"> 
              <div className="wrap-svg"> 
                <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect width={16} height={16} rx={8} fill="#5FCF86" />
                  <path d="M6.75 10.5L4.25 8" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M11.75 5.5L6.75 10.5" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </div>
              <p className="font-12">Thủ tục chỉ cần CCCD & GPLX</p>
           
            </div>
            <div className="item"> 
              <div className="wrap-svg"> 
                <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect width={16} height={16} rx={8} fill="#5FCF86" />
                  <path d="M6.75 10.5L4.25 8" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M11.75 5.5L6.75 10.5" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </div>
              <p className="font-12">Dịch vụ giao xe tận nhà</p>
           
            </div>
          </div>
          <div className="n-col"> 
            <div className="item"> 
              <div className="wrap-svg"> 
                <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect width={16} height={16} rx={8} fill="#5FCF86" />
                  <path d="M6.75 10.5L4.25 8" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M11.75 5.5L6.75 10.5" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </div>
              <p className="font-12">Thanh toán theo chu kì tháng</p>
           
            </div>
            <div className="item"> 
              <div className="wrap-svg"> 
                <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect width={16} height={16} rx={8} fill="#5FCF86" />
                  <path d="M6.75 10.5L4.25 8" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M11.75 5.5L6.75 10.5" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </div>
              <p className="font-12">Miễn phí bảo dưỡng định kì</p>
           
            </div>
          </div>
        </div>
		<div className="line-page" />

		<div className="note-content"> 
			<div className="item">
			<p className="font-12">Bạn cần tư vấn, gọi ngay hotline <a className="text-primary fontWeight-7" href="tel:19009217">1900 9217 </a>hoặc nhắn tin qua <a className="text-primary fontWeight-7" href="https://www.messenger.com/t/mioto.vn">Mioto Fanpage </a>để được hỗ trợ.</p>
			</div>
      </div>
						{/* <div className="price">
					
								<>
								{priceSummary && priceSummary.priceOrigin !== priceSummary.priceSpecial && 
									(
										<div className="price-discount">
											<p className="origin">{formatPrice(priceSummary.priceOrigin)}</p>
											{totalDiscountPercent > 0 ? (
												<span className="tag-item discount">-{totalDiscountPercent}%</span>
											) : null}
										</div>
									)}
									
			
									{priceSummary && <h4>{formatPrice(priceSummary.priceSpecial)}/tháng</h4>}

									<p className="price-note">Giá đã bao gồm VAT, phí bảo hiểm, giao nhận &amp; dịch vụ bảo dưỡng xe</p>
								</>
							
						</div> */}

					
				

						{/* <div className="content-inner"> 
							<p className="title fontWeight-8">Năm sản xuất </p>
							<div className="content-box year-place"> 
								{car.years.map((year, i) => <div className="custom-radio" key={i}> 
									<input type="radio" id={`tYear${i}`} name="rTYear" value={year.yearFrom} checked={year.yearFrom == yearPicker?.yFrom} onChange={(e) => this.onYearPickerChange(e, year)} />
									<label htmlFor={`tYear${i}`}>
										<div className={`text ${car.years.length === 1 ? 'item-radius' : ''}`}>
											<p className="year-item">{year.yearFrom === year.yearTo ? year.yearFrom : `${year.yearFrom} - ${year.yearTo}`}</p>
											{year.stock > 0 ? <p className="year-item">({year.stock} xe)</p> : null}
										</div>
									</label>
								</div>)}
								
							</div>
						</div> */}
  
					{/* <div className="content-inner"> 
						<div className="search-option">
						
							
						</div>
					</div> */}
					{/* {isOwner && (
						<div className="calendar d-flex">
							<div className="wrap-svg" style={{ marginBottom: "12px", marginRight: "5px" }}>
								<IcInfomationTriangle />
							</div>
							<p className="note text-danger">Bạn không thể thuê xe của mình.</p>
						</div>
					)} */}
				

			
					{/* <div className="content-inner"> 
						<p className="title fontWeight-8">Bạn muốn nhận xe khi nào?</p>
						<div className="options-place"> 
							{listPickupRange.map((date, i) => <div className="custom-radio" key={`r${i}`}>
								<input id={`rP${date.key}`} type="radio" name="rRangePickup" value={date.key} onChange={this.onStartDateChange} checked={numberDay == date.key} />
								<label htmlFor={`rP${date.key}`}>{date.label}</label>
							</div>)}
					
							<div className="custom-radio">
								<input id="rP0" type="radio" name="rRangePickup" value={0} checked={numberDay === 0} onChange={this.onStartDateChange} />
								<label htmlFor="rP0">{numberDay !== 0 ? "Thời gian khác" : <span onClick={this.showCalendar}>{st?.format("DD/MM/YYYY")}</span>}</label> 
							</div>
						</div>
					</div> */}
			
							
							<a className="btn btn-primary btn--m width-100" onClick={this.rentCarBtnClick}>CHỌN THUÊ</a>
							{/* <p className="fontWeight-6">Bạn cần tư vấn, gọi ngay hotline <a href="tel:19009217" class="text-primary"> <strong>1900 9217 </strong></a> hoặc nhắn tin qua <a target="_blank" href="https://www.messenger.com/t/mioto.vn" class="text-primary"><strong> Mioto Fanpage </strong></a>để được hỗ trợ</p> */}
						</div>
					

						{/* <div className="highlight-content"> 
							<p>Bạn cần tư vấn, gọi ngay hotline <a href="tel:19009217"> <strong>1900 9217 </strong></a> hoặc nhắn tin qua <a target="_blank" href="https://www.messenger.com/t/mioto.vn"><strong> Mioto Fanpage </strong></a>để được hỗ trợ</p>
						</div> */}

						</div>					

						
			
					{/* <Surcharge info={car} /> */}


					{isOptionalDate && <OptionalDate dayAvailable={dayAvailable} show={isOptionalDate} hideModal={this.hideCalendar} isMCalendar={isMCalendar} startDate={st} onDateChange={this.onCustomDateChange} />}

					<VerifyPhoneBox
						show={this.state.showWarningForm}
						onHide={this.showWarningForm}
						showChangePhone={this.showChangePhone}
					/>

					<VerifyPhoneDL
						show={this.state.showVerifyForm}
						onHide={this.closeVerifyForm}
						openNotifLicense={this.openNotifLicense}
					/>
					<VerifyLicense
						show={this.state.showVerifyLicense}
						onHide={this.closeVerifyLicense}
						openNotifLicense={this.openNotifLicense}
					/>
					<LicenseForm
						show={this.state.showNotifLicense}
						onHide={this.closeNotifLicense}
						showChangeDriverLicense={this.showChangeDriverLicense}
					/>


					{loggedProfile && loggedProfile.uid && (
						<ChangePhone
							show={this.state.showChangePhone}
							hideModal={this.hideChangePhone}
							getProfile={this.getProfile}
							showVerifyPhoneOpt={this.showVerifyPhoneOpt}
						/>
					)}
					{loggedProfile && loggedProfile.uid && (
						<ChangeDriverLicense
							show={this.state.showChangeDriverLicense}
							getProfile={this.getProfile}
							profile={this.props.session.profile}
							hideModal={this.hideChangeDriverLicense}
							showVerifyPhone={this.showChangePhone}
							showVerifyPhoneOpt={this.showVerifyPhoneOpt}
						/>
					)}

					{this.state.showVerifyPhoneOpt && (
						<VerifyPhoneOpt
							show={this.state.showVerifyPhoneOpt}
							hideModal={this.hideVerifyPhoneOpt}
							getProfile={this.getProfile}
							onBreakVerifyPhoneOtp={this.showVerifyPhoneOptBreak}
						/>
					)}
					{this.state.showVerifyPhoneOptBreak && (
						<VerifyPhoneOptBreak show={this.state.showVerifyPhoneOptBreak} hideModal={this.hideVerifyPhoneOptBreak} />
					)}

				
			
				
					{isShowBooking && (
					
								<CSBooking
									closePopup={this.props.closePopup}
									togglePopup={this.props.togglePopup}
									show={isShowBooking}
									hideModal={this.closeBooking}
									car={car}
									skuId={skuId}
									st={st}
									et={et}
									timeCS={timeCS}
									yearPicker={yearPicker}
									priceSummary={priceSummary}
								/>
							)}
					
				
				</>
			);
		}

		return <div className="sidebar-detail">{content}</div>;
	}
}

function mapState(state) {
	return {
		appInit: state.appInit,
		session: state.session,
		csFinding: state.csFinding,
		csDetail: state.csDetail,
	};
}

SideBar = connect(mapState)(SideBar);
export default SideBar;


  {/* <div className="content-inner"> 
      <p className="title fontWeight-8">Thời gian thuê</p>
      <div className="content-box time-place"> 
        <div className="custom-radio"> 
          <input type="radio" id="radio36" name="radio-timeee" defaultChecked />
          <label htmlFor="radio36">
            <div className="text">
              <p className="year-item">0.5 </p>
              <p className="year-item">tháng</p>
            </div>
          </label>
        </div>
        <div className="custom-radio"> 
          <input type="radio" id="radio37" name="radio-timeee" />
          <label htmlFor="radio37">
            <div className="text">
              <p className="year-item">1 </p>
              <p className="year-item">tháng </p>
            </div>
          </label>
        </div>
        <div className="custom-radio"> 
          <input type="radio" id="radio38" name="radio-timeee" />
          <label htmlFor="radio38">
            <div className="text">
              <p className="year-item">2 </p>
              <p className="year-item">tháng </p>
            </div>
          </label>
        </div>
        <div className="custom-radio"> 
          <input type="radio" id="radio39" name="radio-timeee" />
          <label htmlFor="radio39">
            <div className="text">
              <p className="year-item">3 </p>
              <p className="year-item">tháng</p>
            </div>
          </label>
        </div>
        <div className="custom-radio"> 
          <input type="radio" id="radio40" name="radio-timeee" />
          <label htmlFor="radio40">
            <div className="text">
              <p className="year-item">6</p>
              <p className="year-item">tháng </p>
            </div>
          </label>
        </div>
        <div className="custom-radio"> 
          <input type="radio" id="radio41" name="radio-timeee" />
          <label htmlFor="radio41">
            <div className="text">
              <p className="year-item">12</p>
              <p className="year-item">tháng </p>
            </div>
          </label>
        </div>
        <div className="custom-radio"> 
          <input type="radio" id="radio42" name="radio-timeee" />
          <label htmlFor="radio42">
            <div className="text">
              <div className="wrap-svg"> 
                <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M13.0078 3.2334H14.3811" stroke="#666666" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M2.04785 3.2334H10.2678" stroke="#666666" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M11.6409 4.59354C12.3994 4.59354 13.0143 3.98464 13.0143 3.23354C13.0143 2.48243 12.3994 1.87354 11.6409 1.87354C10.8825 1.87354 10.2676 2.48243 10.2676 3.23354C10.2676 3.98464 10.8825 4.59354 11.6409 4.59354Z" stroke="#666666" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M13.0078 12.7671H14.3811" stroke="#666666" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M2.04785 12.7671H10.2678" stroke="#666666" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M11.6409 14.1267C12.3994 14.1267 13.0143 13.5178 13.0143 12.7667C13.0143 12.0156 12.3994 11.4067 11.6409 11.4067C10.8825 11.4067 10.2676 12.0156 10.2676 12.7667C10.2676 13.5178 10.8825 14.1267 11.6409 14.1267Z" stroke="#666666" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M6.16113 8H14.3811" stroke="#666666" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M2.04785 8H3.42118" stroke="#666666" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M4.78739 9.36014C5.54587 9.36014 6.16075 8.75124 6.16075 8.00014C6.16075 7.24903 5.54587 6.64014 4.78739 6.64014C4.02892 6.64014 3.41406 7.24903 3.41406 8.00014C3.41406 8.75124 4.02892 9.36014 4.78739 9.36014Z" stroke="#666666" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </div>
            </div>
          </label>
        </div>
      </div>
	  
    </div> */}